module.exports = __webpack_public_path__ + "img/28.cf13f533.jpg";